import React, { Component } from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';

class DateRange extends Component {
    static defaultProps = {
        numberOfMonths: 1,
        showButton: true,
        from: undefined,
        to: undefined
    };

    constructor(props) {
        super(props);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleResetClick = this.handleResetClick.bind(this);
        this.state = this.getInitialState();
    }

    componentDidUpdate(prevProps) {
        if (this.props.from !== prevProps.from) {
            this.setState({
                from: this.props.from
            })
        }

        if (this.props.to !== prevProps.to) {
            this.setState({
                to: this.props.to
            })
        }
    }

    getInitialState() {
        return {
            from: this.props.from,
            to: this.props.to,
        };
    }

    handleDayClick(day) {
        const range = DateUtils.addDayToRange(day, this.state);
        this.setState(range);
        if (range.from !== undefined && range.to !== undefined && range.from !== null && range.to !== null) {
            this.props.getDateRange(range.from.toISOString(), range.to.toISOString())
        }
    }

    handleResetClick() {
        this.setState({ 
            from: undefined,
            to: undefined    
        });
        this.props.resetDateRange();
    }

    render() {
        const { from, to } = this.state;
        const modifiers = { start: from, end: to };
        return (
            <div id="dpldaterange" className="border border-gray rounded flex justify-center flex-col">
                <DayPicker
                    className="Selectable"
                    numberOfMonths={this.props.numberOfMonths}
                    selectedDays={[from, { from, to }]}
                    modifiers={modifiers}
                    onDayClick={this.handleDayClick}
                    showOutsideDays
                />
                {
                    this.props.showButton 
                        && (
                            <div className="flex justify-between items-center px-10 pb-2">
                                <button type="button" id="btnreset" className="bg-darkred text-white rounded text-sm px-3 py-1" onClick={() => this.handleResetClick()}>
                                    Reset
                                </button>
                                <button type="button" id="btnsave" className="bg-lightblue text-white rounded text-sm px-3 py-1" onClick={this.props.handleSave}>
                                    Simpan
                                </button>
                            </div>
                        )
                }
            </div>
        );
    }
}

export default DateRange;